module.exports = __webpack_public_path__ + "static/media/as5cr538.2ada051c.png";